import { render, staticRenderFns } from "./autoLogin.vue?vue&type=template&id=cc6b790a"
import script from "./autoLogin.vue?vue&type=script&lang=js"
export * from "./autoLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports